import { calculateEnvironmentByHost } from '@cian/utils';

export enum EChatsApiPath {
  MessageFile = '/v1/get-message-file/',
}

export const getChatsApiHost = () => {
  if (typeof window === 'undefined') {
    return 'https://chats.cian.ru/chats';
  }

  if (!window?.location?.host) {
    return 'https://chats.cian.ru/chats';
  }

  const environment = calculateEnvironmentByHost(window.location.host);

  switch (environment) {
    case 'local':
    case 'development':
      return 'https://master.chats.dev3.cian.ru/public';

    default:
      return 'https://chats.cian.ru/chats';
  }
};
